import { SVGInterface } from "../../interface";

const CaretDuoUp = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20.23 14.885L22 13.115L12 3.11501L2 13.115L3.77 14.885L12 6.65501L20.23 14.885Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M20.23 21.885L22 20.115L12 10.115L2 20.115L3.77 21.885L12 13.655L20.23 21.885Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CaretDuoUp;
